import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { WSNoticeData } from "@web/app/components/wstoast/wstoast.component";

@Injectable({
  providedIn: "root"
})
export class WsBannerPreviewService {
  private readonly bannerPreviewSubject = new BehaviorSubject<WSNoticeData | null>(null);

  readonly bannerPreview$ = this.bannerPreviewSubject.asObservable();

  show(data: WSNoticeData) {
    this.bannerPreviewSubject.next({
      ...data,
      displayType: "banner"
    });
  }

  clear() {
    this.bannerPreviewSubject.next(null);
  }
}
